var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h100b",staticStyle:{"position":"relative"}},[_c('iframe',{attrs:{"src":_vm.src,"width":"100%","height":"100%","frameborder":"0","scrolling":"no"},on:{"load":function($event){return _vm.loadIframePage()}}}),_vm._v(" "),_c('div',{staticClass:"h100b mask mask_msg",staticStyle:{"top":"0","left":"0","z-index":"601","zoom":"1"},attrs:{"id":"pwdMessageBox_mask"}})])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./goingsrc/vueCom/layoutVue/go-iframe.vue